import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { style } from '@vanilla-extract/css';

export const subscribersTag = style({
  selectors: {
    '&:is(&):disabled': {
      color: themeVars.badge.foreground.primary,
      backgroundColor: themeVars.badge.primary.background.idle,
      cursor: 'default',
    },
  },
});
